import React, { useEffect, useState } from 'react';

type AsyncComponentProps = React.PropsWithChildren & {
  delay: number;
};

const AsyncComponent: React.FC<AsyncComponentProps> = (props) => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    setTimeout(() => setShow(true), props.delay);
  }, [props.delay, setShow]);
  if (!show) return null;
  return <>{props.children}</>;
};

export default AsyncComponent;
